<template>
  <div class="secondary-menu">
    <img
      v-for="item in items"
      :key="item"
      @click="this.$emit('changeGames', { param: item })"
      :src="require('@/assets/' + item + '/' + item + '.png')"
      alt=""
      :class="gameName == item ? 'is-active' : ''"
    />
  </div>
</template>

<script>
export default {
  name: "SecondaryMenu",
  props: {
    items: [],
    gameName: String
  },
  data: () => ({
    showModal: false,
  }),
};
</script>

<style lang="scss">
.secondary-menu {
  img {
    background-color: rgb(141, 141, 148);
    width: 5rem;
    margin-right: 1rem;
    cursor: pointer;
    &.is-active {
      background-color: rgb(34, 34, 112);
    }
  }
}
</style>

